export function parseFileSize(sizeStr) {
    if (typeof sizeStr !== 'string') {
        throw new TypeError('Input must be a string');
    }
    const match = sizeStr.trim().match(/^(\d+(?:\.\d+)?)\s*([a-zA-Z]*)$/);
    if (!match) {
        throw new Error('Invalid file size format');
    }
    const value = parseFloat(match[1]);
    const unit = match[2].toLowerCase();
    const multipliers = {
        '': 1,
        'b': 1,
        'byte': 1,
        'bytes': 1,
        'k': 1024,
        'kb': 1024,
        'kib': 1024,
        'kilobyte': 1024,
        'kilobytes': 1024,
        'm': 1024 * 1024,
        'mb': 1024 * 1024,
        'mib': 1024 * 1024,
        'megabyte': 1024 * 1024,
        'megabytes': 1024 * 1024,
        'g': 1024 * 1024 * 1024,
        'gb': 1024 * 1024 * 1024,
        'gib': 1024 * 1024 * 1024,
        'gigabyte': 1024 * 1024 * 1024,
        'gigabytes': 1024 * 1024 * 1024,
        't': 1024 * 1024 * 1024 * 1024,
        'tb': 1024 * 1024 * 1024 * 1024,
        'tib': 1024 * 1024 * 1024 * 1024,
        'terabyte': 1024 * 1024 * 1024 * 1024,
        'terabytes': 1024 * 1024 * 1024 * 1024,
        'p': 1024 * 1024 * 1024 * 1024 * 1024,
        'pb': 1024 * 1024 * 1024 * 1024 * 1024,
        'pib': 1024 * 1024 * 1024 * 1024 * 1024,
        'petabyte': 1024 * 1024 * 1024 * 1024 * 1024,
        'petabytes': 1024 * 1024 * 1024 * 1024 * 1024
    };
    const multiplier = multipliers[unit];
    if (multiplier === undefined) {
        throw new Error(`Unsupported unit: ${unit}`);
    }
    return Math.floor(value * multiplier);
}
export function formatFileSize(bytes) {
    if (bytes === 0)
        return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
export function validateFiles(files, options) {
    // Normalize files to an array
    if (!(files instanceof Array)) {
        files = [files];
    }
    const errors = [];
    const validFiles = [];
    const invalidFiles = [];
    // Check file count
    if (!options.multiple && files.length > 1) {
        errors.push('Multiple files not allowed');
    }
    if (options.maxFiles && files.length > options.maxFiles) {
        errors.push(`Too many files. Maximum ${options.maxFiles} allowed`);
    }
    // Validate each file
    files.forEach(file => {
        const fileErrors = [];
        // Check file size
        if (options.maxFileSize && file.size > options.maxFileSize) {
            fileErrors.push(`File "${file.name}" is too large (${formatFileSize(file.size)}). Maximum ${formatFileSize(options.maxFileSize)} allowed`);
        }
        // Check file type
        if (options.allowedTypes && options.allowedTypes.length > 0 && !options.allowedTypes.includes(file.type)) {
            fileErrors.push(`File "${file.name}" type "${file.type}" not allowed`);
        }
        if (fileErrors.length > 0) {
            errors.push(...fileErrors);
            invalidFiles.push(file);
        }
        else {
            validFiles.push(file);
        }
    });
    return {
        valid: errors.length === 0,
        errors,
        validFiles,
        invalidFiles
    };
}
